import axios from '../api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth,auth } = useAuth();

    const refresh = async () => {
        const response = await axios.get(
                '/refresh',
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: 'Bearer '+JSON.parse(localStorage.getItem('token')),
                  },
                }
              );
        setAuth(prev => {
            return {
                ...prev,
                roles: response.data.roles,
                accessToken: response.data.accessToken
            }
        });
        return response.data.accessToken;
    }    
    return refresh;
};

export default useRefreshToken;
